/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {closeCloseReportPanel, closeBarReport} from '../../common/report/actions';
import {logout} from '../../common/login/actions';
import {removeErrors} from '../../common/app/actions';
import {openMessage} from '../../common/components/messages/actions';
import {openReportCashboxesCounter} from '../../common/menu/report/cashboxes/actions';

class CloseReport extends React.Component {

    state: State = {
        tryClose: false
    };

    static propTypes = {
        msg: React.PropTypes.object,
        closeCloseReportPanel: React.PropTypes.func,
        openReportCashboxesCounter: React.PropTypes.func,
        openMessage: React.PropTypes.func,
        closeBarReport: React.PropTypes.func,
        logout: React.PropTypes.func,
        error: React.PropTypes.object,
        waitingOrders: React.PropTypes.object,
        removeErrors: React.PropTypes.func,
        bar: React.PropTypes.object,
        deviceId: React.PropTypes.number
    };

    constructor(props) {
        super(props);

        this.closeBarReport = this.closeBarReport.bind(this);
    }

    componentWillMount() {
        const {removeErrors} = this.props;
        removeErrors();
    }

    componentWillUnmount() {
        const {removeErrors} = this.props;
        removeErrors();
    }

    closeBarReport() {
        const {
            closeBarReport, bar, logout, openMessage, openReportCashboxesCounter, deviceId, waitingOrders, msg
        } = this.props;
        const {tryClose} = this.state;

        if (!tryClose) {
            this.setState({tryClose: true});
            openReportCashboxesCounter(true, true);
            return;
        }

        closeBarReport(bar.get('id')).payload.promise
            .then(() => {
                logout(deviceId);
            })
            .catch(res => {
                if (!res.status) {
                    if (!!waitingOrders && waitingOrders.size > 0) {
                        openMessage(msg.menu.message.deviceOffline, `${msg.menu.message.deviceOffline} ${msg.menu.message.notSentBills} ${waitingOrders.size}. ${msg.menu.message.billSendLater}`);
                    } else {
                        openMessage(msg.menu.message.deviceOffline, msg.menu.message.unableCloseReport);
                    }
                    logout(deviceId);
                }
            });
    }

    render() {
        const {closeCloseReportPanel, logout, error, deviceId, msg} = this.props;

        return (
            <div id="close-report" className="pageNotification">
                <h1 className="pageNotification-logo">{msg.global.appName}</h1>

                <div className="pageNotification-content">
                        <h2 className="pageNotification-title">{msg.closeReport.closeDay}</h2>

                        {!error &&
                        <div className="pageNotification-row pageNotification-text">
                            {msg.closeReport.reportOpen}
                        </div>
                        }

                        {!!error &&
                        <div className="pageNotification-row pageNotification-text">
                            {msg.closeReport.cantClose}
                        </div>
                        }
                        {!!error &&
                          <div className="pageNotification-row">
                            <div className="errors">
                                <ul>
                                    {error.map((err, i) =>
                                        <li key={`error-key-${i}`}>{err}</li>
                                    )}
                                </ul>
                            </div>
                          </div>
                        }

                        <div className="pageNotification-row">
                            <button className="btn btn-block btn-green" onClick={() => this.closeBarReport()}>
                                {!!error
                                    ?  msg.closeReport.tryAgain
                                    :  msg.closeReport.closeAndLogout
                                }
                            </button>
                        </div>

                        <div className="pageNotification-row">
                            <button className="btn btn-block" onClick={() => logout(deviceId)}>
                                {msg.closeReport.onlylogout}
                            </button>
                        </div>
                        <div className="pageNotification-row">
                            <button className="btn btn-block btn-red" onClick={() => closeCloseReportPanel()}>
                                {msg.global.back}
                            </button>
                        </div>
                </div>

            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    bar: state.bars.get('bar'),
    error: state.app.get('error'),
    deviceId: state.device.get('id'),
    waitingOrders: state.categories.get('waitingOrders')
}), {closeCloseReportPanel, logout, closeBarReport, removeErrors, openMessage, openReportCashboxesCounter})(CloseReport);



// WEBPACK FOOTER //
// ./src/browser/report/CloseReport.js